import React from 'react';
import { Link } from '@tvg/fuse/link';
import { Typography } from '@tvg/fuse/typography';

import styles from './WeeInfo.module.css';

function WeeInfo(): JSX.Element {
  return (
    <div data-testid="wee-info-wrapper">
      <Typography className={styles.title} type="heading" size="1" data-testid="wee-info-title">
        Waste Electrical and Electronic Equipment
      </Typography>
      <Typography className={styles.text} size="m1" tag="p" type="paragraph" data-testid="wee-info-text">
        Waste Electrical and Electronic Equipment (WEEE) and waste batteries must never be placed in your waste disposal
        or recycling bins. WEEE is taken back free of charge at electrical retail outlets on a one-for-one like-for-like
        basis. There is a bin for small batteries in your local store. Local authority civic amenity facilities also
        take back WEEE and waste batteries free of charge. WEEE and waste battery recycling is free.
      </Typography>

      <Link
        href="https://www.very.ie/help/en/weee-directive.page"
        target="_blank"
        rel="noopener noreferrer"
        dataTestId="wee-info-link"
        size="medium"
      >
        Go to our WEEE policy page to learn more
      </Link>
    </div>
  );
}

export default WeeInfo;
